var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){return _vm.linkedinLink(_vm.url)}}},[_c('i',{staticClass:"fa fa-linkedin fa-2x",staticStyle:{"color":"#0077B5"},attrs:{"scale":_vm.scale}})])}
var staticRenderFns = []

export { render, staticRenderFns }